<template>
  <div class="theme-1">
    <div class="tw-user-profile-card">

      <!-- Identite : avatar, nom, role -->
      <div class="tw-profile-identity">
        <q-avatar size="44px" color="amber" text-color="white" class="tw-profile-avatar">
          {{ initials }}
        </q-avatar>
        <div class="tw-profile-identity-text">
          <span class="tw-profile-name">{{ user.firstName + " " + user.lastName }}</span>
          <span class="tw-profile-role" v-if="userRole">{{ userRole }}</span>
        </div>
      </div>

      <!-- Coordonnees et etat du compte -->
      <ul class="tw-profile-facts">
        <li class="tw-profile-fact">
          <q-icon name="mail_outline" size="16px" class="tw-profile-fact-icon" />
          <span class="tw-profile-fact-value" :title="user.email">{{ user.email }}</span>
        </li>
        <li class="tw-profile-fact">
          <q-icon name="verified_user" size="16px" class="tw-profile-fact-icon" />
          <span class="tw-profile-status" :class="user.loggedIn ? 'is-active' : 'is-inactive'">
            <span class="tw-profile-status-dot"></span>
            {{ user.loggedIn === true
              ? $t('party.account.statut.active')
              : $t('garantie.garantiedetails.statuslist.Inactive') }}
          </span>
        </li>
      </ul>

      <!-- Preference de langue -->
      <!-- <div class="tw-profile-section">
        <label class="tw-profile-section-label">{{ $t("userPreference.language") }}</label>
        <q-select class="tw-profile-lang-select" v-model="user.selectedLanguage" :options="languageOptions"
          hide-dropdown-icon outlined dense @update:model-value="i18nTranslations($event)">
          <template v-slot:append>
            <country-flag v-if="user.selectedLanguage" :country="treatLocale(user.selectedLanguage?.id)?.country"
              size="small" class="rounded-10" />
          </template>
<template v-slot:selected-item="scope">
            <span class="ellipsis">{{ scope.opt.label }}</span>
          </template>
<template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label class="font-size-11">{{ scope.opt.label }}</q-item-label>
              </q-item-section>
              <q-item-section avatar>
                <country-flag :country="treatLocale(scope.opt.id).country" size="small" class="rounded-10" />
              </q-item-section>
            </q-item>
          </template>
</q-select>
</div> -->

      <!-- Action -->
      <button type="button" class="tw-profile-action" @click="UserPreference">
        <q-icon name="settings" size="18px" class="tw-profile-action-icon" />
        <span class="tw-profile-action-label">{{ $t("userPreference.userPreference") }}</span>
        <q-icon name="chevron_right" size="18px" class="tw-profile-action-chevron" />
      </button>

    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import store from "@/store";
import router from "@/router";
import { getTranslations, treatLocale } from "@/i18n.service.handler";
import { getConnectedUserRoleLabel } from "@/utils/user-role";



export default class profile extends Vue {
  language = "";

  i18nTranslations = getTranslations;
  treatLocale = treatLocale;

  get user() {
    return store?.state?.authModule?.user;
  }
  /** Libellé de rôle mutualisé avec le header, cf. utils/user-role.ts */
  get userRole() {
    return getConnectedUserRoleLabel();
  }
  get initials() {
    const firstInitial = this.user?.firstName?.trim()?.charAt(0) || '';
    const lastInitial = this.user?.lastName?.trim()?.charAt(0) || '';
    const initials = `${firstInitial}${lastInitial}`.toUpperCase();

    return initials || '--';
  }
  get languageOptions() {
    return store.getters["authModule/getUserConnected"].preferredLanguages
  }

  UserPreference() {
    store.dispatch("userModule/setMode", "edit");
    router.push("/profile");
  }
}
</script>
<!-- Styles de la carte de profil : centralises dans src/css/_theme.scss -->
